<script lang="ts">
	import { Information, Warning, Error, Close, CheckmarkOutline } from 'carbon-icons-svelte';
	import type { ToastData } from './types';
	import { getToastState } from './toast-state.svelte';
	import { fade } from 'svelte/transition';
	import { cubicInOut } from 'svelte/easing';
	import DOMPurify from 'dompurify';

	let {
		toast
	}: {
		toast: ToastData;
	} = $props();

	const toastState = getToastState();
</script>

<div
	class="max-w-full w-md bg-white shadow-md rounded-md overflow-hidden"
	transition:fade={{ duration: 750, easing: cubicInOut }}
>
	<div class="flex w-full min-h-[80px]">
		<div class="basis-[75px]">
			<div class="text-center w-full h-full px-2 bg-{toast.type} flex items-center">
				{#if toast.type === 'info'}
					<div class="text-white mx-auto">
						<Information size={32} class="scale-90" />
					</div>
				{:else if toast.type === 'success'}
					<div class="text-white mx-auto">
						<CheckmarkOutline size={32} class="scale-90" />
					</div>
				{:else if toast.type === 'warning'}
					<div class="text-secondary mx-auto">
						<Warning size={32} class="scale-90" />
					</div>
				{:else if toast.type === 'error'}
					<div class="text-white mx-auto">
						<Error size={32} class="scale-90" />
					</div>
				{/if}
			</div>
		</div>
		<div class="basis-full">
			<div class="px-4 py-6 relative">
				<div class="pe-8">
					<p class="text-md font-semibold">{toast.title}</p>
					<button
						class="absolute p-0 top-4 right-4 opacity-75 hover:opacity-100 duration-150"
						onclick={() => toastState.removeToast(toast.id)}><Close size={24} /></button
					>
				</div>
				<div>
					<!-- String is sanitized -->
					<!-- eslint-disable-next-line svelte/no-at-html-tags -->
					<p class="text-[13px] wrap-anywhere">{@html DOMPurify.sanitize(toast.description)}</p>
				</div>
			</div>
		</div>
	</div>
</div>
